/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEvaluationSurveyType } from './en-evaluation-survey-type';
import { EvaluationSurveyQuestionDto } from './evaluation-survey-question-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface EvaluationSurveyDto
 */
export interface EvaluationSurveyDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof EvaluationSurveyDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EvaluationSurveyDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof EvaluationSurveyDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof EvaluationSurveyDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof EvaluationSurveyDto
     */
    title: string;

    /**
     * @type {string}
     * @memberof EvaluationSurveyDto
     */
    description: string | null;

    /**
     * @type {EnEvaluationSurveyType}
     * @memberof EvaluationSurveyDto
     */
    type: EnEvaluationSurveyType;

    /**
     * @type {JoinEntityDto}
     * @memberof EvaluationSurveyDto
     */
    client: JoinEntityDto;

    /**
     * @type {Array<EvaluationSurveyQuestionDto>}
     * @memberof EvaluationSurveyDto
     */
    questions: Array<EvaluationSurveyQuestionDto>;
}
